import { AuthService } from "@js/services/AuthService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { UserService } from "@js/services/UserService";
import {
  ApplicantRoleEnum,
  ApplicationUser,
  ApplicationUserCrudClient,
  AppPackagePricing,
  DevelopmentInputClient,
  FileAttachment,
  HubspotContactRequest,
  Introducer,
  IntroducerClient,
  IntroducerTypeEnum,
  InvitedBrokerDTO,
  Organisation,
  OrganisationClient,
  OrganisationTypeEnum,
  PaymentClient,
  PricingFrequencyEnum,
  ProductTypeEnum,
  RegisterOrganisationDTO,
  UserClient,
  UserRoleEnum,
} from "@src/apis/ModularClient";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { Expand, getOneUsingOData } from "@ccq/ts-lib";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class RegistrationBrokerController {
  bar: number = 0;
  formEntered: boolean[] = [false, false, false, false, false, false, false, false, false, false, false, false, false];
  step: number = 1;
  stepName: string = "";
  seats: number = 1;
  dataLoading: boolean = false;
  progressBar: {
    step: number;
    label: string;
    active: boolean;
    complete: boolean;
  }[] = [
    { step: 1, label: "About you", active: false, complete: false },
    { step: 2, label: "About your business", active: false, complete: false },
    {
      step: 3,
      label: "More about your business",
      active: false,
      complete: false,
    },
    { step: 4, label: "Assign licenses", active: false, complete: false },
  ];

  aboutYouSection: boolean = false;
  aboutYourBusinessSection: boolean = false;
  moreAboutYourBusinessSection: boolean = false;
  user: Expand<ApplicationUser> = {
    isOrganisationAdmin: true,
    applicantDefinedRole: ApplicantRoleEnum.Introducer,
    applicantDefinedRoleIntroducer: IntroducerTypeEnum.Broker,
  } as Expand<ApplicationUser>;

  selectedPackage: AppPackagePricing;

  organization: Organisation;
  userEmails: InvitedBrokerDTO[] = [];
  newUser: InvitedBrokerDTO = {
    email: null,
    firstName: null,
  };
  tempdata: InvitedBrokerDTO;
  //tour
  welcomeMessage: string =
    "Welcome to the Brickflow for Brokers - to setup your account we need some details on you and your company.";
  tourOrder: number = 1;

  registrationFormStep1: ng.IFormController;
  registrationFormStep2: ng.IFormController;
  registrationFormStep3: ng.IFormController;

  //display Logos
  companyLogo: FileAttachment;
  profileLogo: FileAttachment;

  error: string;

  // TODO - JLH - what are these variables?  can we improve the naming?
  //rename Email
  renamingItem: InvitedBrokerDTO;
  newName: InvitedBrokerDTO;

  passwordError: boolean = false;

  isProcessingRegister: boolean = false;

  // Show and hide a input field to add users.
  hideInput: boolean = false;
  showErrorMsg: boolean = false;
  confirmPassword: string;
  selectedProductList: AppPackagePricing[] = [];

  isPayClicked: boolean = false;

  isConvertingExistingUser: boolean = false;

  orgUniqueRef: string;
  orgNameToAssign: string;
  isProceedClicked: boolean = false;
  confirmAssignToOrg: boolean = false;
  isAddonselected: boolean = false;

  locationOptions = [];
  referrerOptions = [];

  password: string;

  static $inject = [
    "FileAttachmentHelper",
    "$routeParams",
    "$cookies",
    "$location",
    "RoleService",
    "$rootScope",
    "OrganisationClient",
    "AuthService",
    "IntroducerClient",
    "$window",
    "UserService",
    "UserClient",
    "DevelopmentInputClient",
    "PaymentService",
    "SelectListService",
    "OrganisationClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "ODataHelper",
  ];

  constructor(
    private fileAttachmentHelper: FileAttachmentHelper,
    private $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $roleService: RoleService,
    private $rootScope: ng.IRootScopeService,
    private organisationClient: OrganisationClient,
    private $auth: AuthService,
    private introduceClient: IntroducerClient,
    private $window: ng.IWindowService,
    private userService: UserService,
    private userClient: UserClient,
    private developmentInputClient: DevelopmentInputClient,
    private paymentClient: PaymentClient,
    private selectListService: SelectListService,
    private $organisationClient: OrganisationClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private indexService: IndexService,
    private odataHelper: ODataHelper,
  ) {
    //TODO Change for New pricing
    window.location.assign("https://brickflow.com/pricing");

    // If we have an introducer code set, let's store a cookie.
    if (this.$routeParams["ic"]) {
      var expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 100);
      this.$cookies.put("introducer_code", this.$routeParams["ic"], {
        expires: expiryDate,
      });
    }

    if (this.$routeParams["orgc"]) {
      var expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 100);
      this.$cookies.put("org_code", this.$routeParams["orgc"], {
        expires: expiryDate,
      });
    }

    if (this.$routeParams["orguniqueref"]) {
      this.orgUniqueRef = this.$routeParams["orguniqueref"];
      this.user.isOrganisationAdmin = false;

      this.organisationClient.findOrganisationByUniqueRef(this.orgUniqueRef).then((org: Organisation) => {
        this.orgNameToAssign = org.name;
      });
    }

    /* window.onbeforeunload = function (event) {
                //console.log(event);
                //console.log(this.registrationFormStep1.$invalid);
                /*fetch("/api/organisation/brokersignupjourneyg2email?brokerEmail=" + this.user.email + "&brokerFirstName=" + this.user.firstName + "&brokerLastName=" + this.user.lastName, {
                    method: "GET",
                    keepalive: true,
                 });*/
    //navigator.sendBeacon("/api/organisation/brokersignupjourneyg2email?brokerEmail=" + this.user.email + "&brokerFirstName=" + this.user.firstName + "&brokerLastName=" + this.user.lastName);
    /* if (this.user.email != null && this.user.firstName != null && this.user.lastName != null ) {
                    this.organisationClient.brokerSignUpJourneyG2Email(this.user.email, this.user.firstName, this.user.lastName).then((response) => {
                    });
                }
        }*/

    if (this.$cookies.get("access_token")) {
      this.initialiseUserData();
    } else {
      if (sessionStorage.getItem("userDetails")) {
        let data = sessionStorage.getItem("userDetails");
        let userdetails = JSON.parse(data);

        let userFullName = userdetails.FullName;
        let spaceIndex = userFullName.indexOf(" ");

        let firstName = "";
        let lastName = "";

        // if not space has been added to the name then put the whole name in the first name field
        if (spaceIndex == -1) {
          firstName = userFullName;
        } else {
          firstName = userFullName.substring(0, userFullName.indexOf(" "));
          lastName = userFullName.substring(userFullName.indexOf(" ") + 1);
        }

        this.user.firstName = firstName;
        this.user.lastName = lastName;
        this.user.email = userdetails.Email;
        this.user.phoneNumber = userdetails.PhoneNumber;
      }
    }

    if (sessionStorage.getItem("selectedPackage")) {
      let data = sessionStorage.getItem("selectedPackage");
      this.selectedPackage = JSON.parse(data);
    }

    this.referrerOptions = this.selectListService.GetReferrerOptions();
    this.locationOptions = this.selectListService.GetLocations();
  }

  private async initialiseUserData() {
    this.user = await getOneUsingOData(this.applicationUserCrudClient, {
      filter: { id: { eq: await this.indexService.currentUserId } },
    });

    if (this.user.isLegacyUser || this.orgUniqueRef) {
      this.isConvertingExistingUser = this.user.isLegacyUser;

      this.user.isOrganisationAdmin = !this.orgUniqueRef ? true : false;
      this.user.applicantDefinedRole = ApplicantRoleEnum.Introducer;
      this.user.applicantDefinedRoleIntroducer = IntroducerTypeEnum.Broker;
    } else {
      this.$roleService.goHomeBasedOnUser();
    }
  }

  change() {
    if (this.confirmPassword) {
      if (this.confirmPassword !== this.password) {
        this.error = "Passwords do not match";
      } else {
        delete this.error;
      }
    }
  }

  addNewUser() {
    if (this.newUser.email != null && this.newUser.firstName != null) {
      var temp = { ...this.newUser };
      this.userEmails.push(temp);
      this.newUser.email = null;
      this.newUser.firstName = null;
      // this.registrationForm.newUserFirstName.$setUntouched()
      //  this.registrationForm.newUserEmail.$setUntouched();
    }
  }

  removeNewUserEmail(event) {
    event.preventDefault();
    delete this.newUser;
  }

  cancelAddingNewUser() {
    this.newUser.email = null;
    this.newUser.firstName = null;
    // this.registrationForm.newUserFirstName.$setUntouched();
    //this.registrationForm.newUserEmail.$setUntouched()
  }

  getFocusToInput() {
    var getelement = this.$window.document.getElementById("newuser");
    getelement.focus();
  }

  changeCompanyLogo(files) {
    if (files.length > 0) {
      this.fileAttachmentHelper.uploadPublicImage(files, this.organization.organisationCode).then((result) => {
        if (result) {
          this.organization.logoURL = result;
        }
      });
    }
  }

  changeProfileLogo(files) {
    if (files.length > 0) {
      this.fileAttachmentHelper.uploadFileAndReturnURI(files).then((result) => {
        if (result) {
          this.profileLogo = result;
        }
      });
    }
  }

  registerAccount() {
    this.isPayClicked = true;
    this.confirmAssignToOrg = false;
    this.dataLoading = true;
    this.getStepName();

    if (!this.orgUniqueRef && !this.user.isLegacyUser && this.confirmPassword !== this.password) {
      this.passwordError = true;
      this.dataLoading = false;
      this.isPayClicked = false;
    } else {
      let hubspotContactRequest: HubspotContactRequest = {
        user: this.user,
        page: this.stepName,
        login: true,
        orgCode: this.$cookies.get("org_code"),
        role: parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum,
        organisationLinkId: 0,
        productType: ProductTypeEnum.None,
        dealId: null,
        developmentInputWithNoLoginUniqueRef: "",
        clientId: null,
      };
      this.userClient.sendEventToHubspot(hubspotContactRequest);
      this.passwordError = false;
      this.user.userName = this.user.email;
      this.userRegistration();
    }
  }

  userRegistration() {
    this.isProcessingRegister = true;

    this.user.profilePictureUrl = this.profileLogo ? this.profileLogo.fileLocation : null;

    if (this.$cookies.get("introducer_code")) {
      this.user.introducerCode = this.$cookies.get("introducer_code");
    }

    if (this.orgUniqueRef) {
      this.organisationClient
        .registerBroker(this.orgUniqueRef, this.user as ApplicationUser)
        .then((convertedBrokerDto: ApplicationUser) => {
          // clean up local storage
          sessionStorage.removeItem("userDetails");
          sessionStorage.removeItem("userRole");
          sessionStorage.removeItem("projectname");

          (this.$rootScope as any).selectedUser = convertedBrokerDto;

          this.$auth
            .newLogin(this.user.email, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
            .then((response) => {
              let expiry: Date = response;

              this.$cookies.put("user_firstname", this.user.firstName, {
                expires: expiry,
              });

              this.cleanupAfterConversion();
            })
            .catch((response) => {
              this.error = response.data.Message;
              this.isProcessingRegister = false;
            });
        })
        .catch((response) => {
          this.error = response.data.ExceptionMessage;
          this.isProcessingRegister = false;
          this.dataLoading = false;
        })
        .finally(() => {
          this.dataLoading = false;
        });
    } else {
      this.organization.organisationType = OrganisationTypeEnum.Broker;
      this.organization.commissionPercent = 0.01;

      this.user.location = this.organization.location;

      var registerOrgDto: RegisterOrganisationDTO = {
        organisationDTO: this.organization,
        organisationAdminUserDTO: this.user as ApplicationUser,
        inviteOrganisationUsers: this.userEmails,
      };

      this.organisationClient
        .registerOrganisation(registerOrgDto)
        .then((registerOrganisationDto: RegisterOrganisationDTO) => {
          // clean up session storage
          sessionStorage.removeItem("userDetails");
          sessionStorage.removeItem("userRole");
          sessionStorage.removeItem("projectname");

          (this.$rootScope as any).selectedUser = registerOrganisationDto.organisationAdminUserDTO;

          if (this.$cookies.get("access_token") && this.isConvertingExistingUser) {
            this.cleanupAfterConversion();
          } else if (!this.$cookies.get("access_token")) {
            // Automatically log in the broker org admin
            this.$auth
              .newLogin(this.user.email, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
              .then((response) => {
                let expiry: Date = response;

                this.$cookies.put("user_firstname", this.user.firstName, {
                  expires: expiry,
                });

                this.onRegistrationComplete();
              })
              .catch((response) => {
                this.error = response.data.Message;
                this.isProcessingRegister = false;
              });
          } else {
            this.error = "logged in but not converting an existing user";
            this.isProcessingRegister = false;
            this.dataLoading = false;
          }
        })
        .catch((response) => {
          this.error = response.data.ExceptionMessage;
          this.isProcessingRegister = false;
          this.dataLoading = false;
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }

  onRegistrationComplete() {
    if (this.selectedPackage) {
      /* this.selectedPackage.Quantity = this.seats;*/
      this.selectedProductList.push(this.selectedPackage);
      this.createCheckoutSession();
    } else {
      this.$location.path("/userdashboard");
    }
  }

  cleanupAfterConversion() {
    // clear and reset cached data based on the new information
    this.$roleService.GetUserRoles(true); //reset user roles

    sessionStorage.setItem("isUpgradedUser", "true");

    this.onRegistrationComplete();
  }

  registerDisabled() {
    if (this.organization && this.organization.location && this.organization.phoneNumber) {
      return false;
    } else {
      return true;
    }
  }

  registerIntroducerByUserId(userId: string): void {
    var introducer = {
      userId: parseInt(userId),
      isIndividual: false,
      introducerType: IntroducerTypeEnum.Broker,
      companyName: this.organization.name,
      companyURL: this.organization?.companyURL,
    } as Introducer;

    this.introduceClient
      .registerIntroducer(true, introducer)
      .then((success) => {})
      .catch((error) => {
        this.error =
          "It looks like there was a problem registering you as an introducer. Please try again in a moment.";
      });
  }

  removeEmail(item: InvitedBrokerDTO) {
    this.userEmails = this.userEmails.filter((x) => x != item);
  }

  renameItem(item: InvitedBrokerDTO) {
    if (this.renamingItem === undefined) {
      this.renamingItem = item;
      this.newName = item;
      this.tempdata = { ...this.renamingItem };
    } else {
      delete this.renamingItem;
    }
  }

  renamingItemComplete(item: InvitedBrokerDTO) {
    this.userEmails = this.userEmails.filter((x) => x != item);
    this.userEmails.push(this.newName);
    this.renamingItem = null;
  }

  cancelRenaming(item: InvitedBrokerDTO) {
    this.userEmails = this.userEmails.filter((x) => x != item);
    this.userEmails.push(this.tempdata);
    delete this.renamingItem;
    //this.registrationForm.editUserEmail.$setUntouched()
    //this.registrationForm.editUserFirstName.$setUntouched()
  }

  /*   back() {
            this.tourOrder--;
            this.welcomeMessage = "Welcome to the Brickflow for Brokers - to setup your account we need some details on you and your company.";
        }
        next() {
            this.tourOrder++;
            this.welcomeMessage = "Impress your clients with Brickflow Plus; add your company logo and profile picture, to personalise the software.";
        }
        */

  fillRegisterForm() {
    let name = new Date().toLocaleString().replace(/ |,|:|\/|/g, "");
    this.organization.name = name;
    this.organization.companyURL = "www.google.com";
    this.organization.location = 1;
    this.organization.phoneNumber = "12345677";
    this.user.email = `${name}@test.com`;
    this.user.firstName = `${name}Admin`;
    this.user.lastName = "t";
    this.user.phoneNumber = "12345677";
    this.user.referrer = 1;
    this.user.representative = "None";
    this.organization.fcaNumber = "12344";
    this.organization.tagLine = `${name}tag`;
    this.password = "test";
    this.confirmPassword = "test";
  }

  next() {
    this.getStepName();

    if (!this.user.isLegacyUser) {
      this.odataHelper
        .getOne(this.applicationUserCrudClient, {
          filter: {
            email: {
              eq: this.user.email,
            },
          },
          select: { id: true },
        })
        .then((emailExists) => {
          if (emailExists.id != null) {
            this.error = "Email address is already in use, please sign in.";
          } else {
            const hubspotContactRequest: HubspotContactRequest = {
              user: this.user,
              page: this.stepName,
              login: false,
              orgCode: this.$cookies.get("org_code"),
              role: parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum,
              organisationLinkId: 0,
              productType: ProductTypeEnum.None,
              dealId: null,
              developmentInputWithNoLoginUniqueRef: "",
              clientId: null,
            };
            this.userClient.sendEventToHubspot(hubspotContactRequest);
            this.step++;
          }
        });
    } else {
      let hubspotContactRequest: HubspotContactRequest = {
        user: this.user,
        page: this.stepName,
        login: false,
        orgCode: this.$cookies.get("org_code"),
        role: parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum,
        organisationLinkId: 0,
        productType: ProductTypeEnum.None,
        dealId: null,
        developmentInputWithNoLoginUniqueRef: "",
        clientId: null,
      };
      this.userClient.sendEventToHubspot(hubspotContactRequest);
      this.step++;
    }
  }

  back() {
    this.step--;
  }

  proceed() {}

  calculateBarPercentage(index: number, value: string) {
    if (!this.formEntered[index] && (value || value != "")) {
      this.bar += 8;
      this.formEntered[index] = !this.formEntered[index];
    } else if (this.formEntered[index] && (value == undefined || value == "" || value == null)) {
      this.bar -= 8;
      this.formEntered[index] = !this.formEntered[index];
    }
  }

  isFirstStepValid() {
    if (!this.registrationFormStep1.$invalid && !this.error && !this.passwordError) {
      this.progressBar[0].complete = true;
      return true;
    } else {
      this.progressBar[0].complete = false;
      return false;
    }
  }

  isSecondStepValid() {
    if (!this.registrationFormStep2.$invalid) {
      this.progressBar[1].complete = true;
      return true;
    } else {
      this.progressBar[1].complete = false;
      return false;
    }
  }

  isThirdStepValid() {
    if (
      !this.registerDisabled() &&
      this.user.agreedToTermsAndPP === true &&
      !this.isProcessingRegister &&
      !this.registrationFormStep3.$invalid
    ) {
      this.progressBar[2].complete = true;
      return true;
    } else {
      this.progressBar[2].complete = false;
      return false;
    }
  }

  getTotalCost(): number {
    if (this.selectedPackage) {
      return this.selectedPackage.priceAmount * this.seats;
    } else {
      return 0;
    }
  }

  getPricingFrequency(): string {
    var frequencyText = "Month";
    if (this.selectedPackage) {
      switch (this.selectedPackage.pricingFrequency) {
        case PricingFrequencyEnum.Yearly: {
          frequencyText = "Year";
          break;
        }
        case PricingFrequencyEnum.Monthly:
        default:
          frequencyText = "Month";
      }
    }
    return frequencyText;
  }

  createCheckoutSession() {
    //this.selectedProductList[0].SelectedModuleAppFeature = this.moduleAppFeatures;
    // Need to save the search so we can get back to it after payment ($rootscope will lose the data)
    if (sessionStorage.getItem("addAddon")) {
      this.isAddonselected = sessionStorage.getItem("addAddon") == "true" ? true : false;
    }

    if ((this.$rootScope as any).loanCriteria != null) {
      (this.$rootScope as any).loanCriteria.UserId = (this.$rootScope as any).selectedUser.Id;
      (this.$rootScope as any).loanCriteria.BrokerOrganisationId = (this.$rootScope as any).selectedUser.OrganisationId;
      this.developmentInputClient
        .saveSearch((this.$rootScope as any).loanCriteria)
        .then((developmentInputId: number) => {
          this.paymentClient
            .createCheckoutSession(this.isAddonselected, "", this.selectedPackage, developmentInputId)
            .then((response) => {
              window.location.assign(response.sessionUrl);
            });
        });
    } else {
      this.paymentClient
        .createCheckoutSession(this.isAddonselected, "", this.selectedPackage, null)
        .then((response) => {
          window.location.assign(response.sessionUrl);
        });
    }
  }

  cancelCheckout() {
    if ((this.$rootScope as any).loanCriteria) {
      this.$location.path("/results");
    } else {
      this.$location.path("/userdashboard");
    }
  }

  getApplicationName() {
    if (sessionStorage.getItem("applicationName") != null) {
      return sessionStorage.getItem("applicationName");
    } else {
      return "Brickflow";
    }
  }

  getStepName() {
    switch (this.step) {
      case 1:
        this.stepName = "REGISTRATIONUSERDETAILS";
        break;
      case 2:
        this.stepName = "REGISTRATIONCOMPANYDETAILS";
        break;
      case 3:
        this.stepName = "REGISTATIONFINALSTEP";
        break;
    }
  }
}
